<template>
    <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
        <div class="bg-white w-full rounded-lg shadow pb-20">
            <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
                <div class="flex w-full">
                   <button
                        :class="$colors.primary"
                        class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
                        @click="RouterBack()"
                    > <i class="material-icons">chevron_left</i>
                    </button>
                    <div class="text-xl font-bold text-green-700  ">Pointage</div>
                </div>
            </div>
              <div class="mx-4" v-if="pointages.length>0">
                <table class="w-full">
                        <thead class="ant-table-thead">
                            <tr>
                                <th class="float-right font-semibold" style="background: none;border: none;color: inherit;">
                                    <button @click="$vm2.open('Params')" class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                       
                                        <svg class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 8.666c-1.838 0-3.333 1.496-3.333 3.334s1.495 3.333 3.333 3.333 3.333-1.495 3.333-3.333-1.495-3.334-3.333-3.334m0 7.667c-2.39 0-4.333-1.943-4.333-4.333s1.943-4.334 4.333-4.334 4.333 1.944 4.333 4.334c0 2.39-1.943 4.333-4.333 4.333m-1.193 6.667h2.386c.379-1.104.668-2.451 2.107-3.05 1.496-.617 2.666.196 3.635.672l1.686-1.688c-.508-1.047-1.266-2.199-.669-3.641.567-1.369 1.739-1.663 3.048-2.099v-2.388c-1.235-.421-2.471-.708-3.047-2.098-.572-1.38.057-2.395.669-3.643l-1.687-1.686c-1.117.547-2.221 1.257-3.642.668-1.374-.571-1.656-1.734-2.1-3.047h-2.386c-.424 1.231-.704 2.468-2.099 3.046-.365.153-.718.226-1.077.226-.843 0-1.539-.392-2.566-.893l-1.687 1.686c.574 1.175 1.251 2.237.669 3.643-.571 1.375-1.734 1.654-3.047 2.098v2.388c1.226.418 2.468.705 3.047 2.098.581 1.403-.075 2.432-.669 3.643l1.687 1.687c1.45-.725 2.355-1.204 3.642-.669 1.378.572 1.655 1.738 2.1 3.047m3.094 1h-3.803c-.681-1.918-.785-2.713-1.773-3.123-1.005-.419-1.731.132-3.466.952l-2.689-2.689c.873-1.837 1.367-2.465.953-3.465-.412-.991-1.192-1.087-3.123-1.773v-3.804c1.906-.678 2.712-.782 3.123-1.773.411-.991-.071-1.613-.953-3.466l2.689-2.688c1.741.828 2.466 1.365 3.465.953.992-.412 1.082-1.185 1.775-3.124h3.802c.682 1.918.788 2.714 1.774 3.123 1.001.416 1.709-.119 3.467-.952l2.687 2.688c-.878 1.847-1.361 2.477-.952 3.465.411.992 1.192 1.087 3.123 1.774v3.805c-1.906.677-2.713.782-3.124 1.773-.403.975.044 1.561.954 3.464l-2.688 2.689c-1.728-.82-2.467-1.37-3.456-.955-.988.41-1.08 1.146-1.785 3.126"/></svg>
                                        <span>Paramétrage</span>
                                    </button>
                                </th>
                            </tr>
                            <tr>
                                <th class="float-left  mb-1 font-semibold" style="background: none;border: none;color: inherit;">Employeur :</th>
                                <th style="background: none;border: none;color: inherit;" class="float-left px-5">{{ pointages[0].datas[0].user.fullName }}</th>
                            </tr>
                            <tr>
                                <th class="float-left mr-5 font-semibold" style="background: none;border: none;color: inherit;">Date de début du calaendrier :</th>
                                <th class="float-left px-5"> {{ $route.query.Range_date.split(',')[0] }}</th>
                            </tr>
                            <tr>
                                <th class="float-left mr-5 font-semibold" style="background: none;border: none;color: inherit;">Date de fin du calaendrier :</th>
                                <th class="float-left px-5">{{ $route.query.Range_date.split(',')[1] }}</th>
                            </tr>
                        </thead>
                    </table>
                    <table class="w-full mt-5">
                        <thead class="ant-table-thead capitalize">
                        <tr>
                            <th style="background: none;border: none;"></th>
                            <th style="background: none;border: none;"></th>
                            <th >Travaille Matin</th>
                            <th>Travaille après-midi</th>
                            <th>Total heures travaillées</th>
                            <th>Total heures d'absence</th>
                        </tr>
                        </thead>
                        <tbody class="capitalize realative">
                            <loading :active.sync="loading" :is-full-page="fullPage"></loading> 
                            <tr  v-for="(item, index) in pointages" :key="index">
                                <th>{{  $moment(item.datas[0].date).format('yyyy-MM-DD') }}</th>
                                <th>{{ $moment(item.datas[0].date).lang("fr").format('dddd') }}</th>
                                <th :style="getColors(checkEmployeur(item.datas,'matin'))">{{ checkEmployeur(item.datas,'matin') }}</th>
                                <th :style="getColors(checkEmployeur(item.datas,'après-midi'))">{{ checkEmployeur(item.datas,'après-midi') }}</th>
                                <th>{{ checkEmployeur(item.datas,null,'present') }}</th>
                                <th>{{ checkEmployeur(item.datas,null,'absent') }}</th>
                            </tr>
                        </tbody>
                    </table>
              </div>
        </div>

        <vue-modal-2  name="Params" :headerOptions="{title: `Paramétrage`}" :noFooter="true" modalSize="lg">
                <div class="rounded-lg mb-14">
                    <div class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative">
                        <!-- <loading :active.sync="dataUpdate.loading" :is-full-page="fullPage"></loading> -->
                        <div class="grid lg:grid-cols-3 gap-6">
                            <button  @click="Action('Ajouter')" :class="dataUpdate.action && dataUpdate.action === 'Ajouter'?'border-4 border-gray-700':''" class="justify-center bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                <svg class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"/></svg>
                                <span>Ajouter jour</span>
                            </button>
                            <button @click="Action('Modifier')" :class="dataUpdate.action && dataUpdate.action === 'Modifier'?'border-4 border-gray-700':''" class="justify-center bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                <svg class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="m11.25 6c.398 0 .75.352.75.75 0 .414-.336.75-.75.75-1.505 0-7.75 0-7.75 0v12h17v-8.75c0-.414.336-.75.75-.75s.75.336.75.75v9.25c0 .621-.522 1-1 1h-18c-.48 0-1-.379-1-1v-13c0-.481.38-1 1-1zm-2.011 6.526c-1.045 3.003-1.238 3.45-1.238 3.84 0 .441.385.626.627.626.272 0 1.108-.301 3.829-1.249zm.888-.889 3.22 3.22 8.408-8.4c.163-.163.245-.377.245-.592 0-.213-.082-.427-.245-.591-.58-.578-1.458-1.457-2.039-2.036-.163-.163-.377-.245-.591-.245-.213 0-.428.082-.592.245z"/></svg>
                                <span>Modifier jour</span>
                            </button>
                            <button @click="Action('Supprimer')" :class="dataUpdate.action && dataUpdate.action === 'Supprimer'?'border-4 border-gray-700':''" class="justify-center bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                <svg class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="m20.015 6.506h-16v14.423c0 .591.448 1.071 1 1.071h14c.552 0 1-.48 1-1.071 0-3.905 0-14.423 0-14.423zm-5.75 2.494c.414 0 .75.336.75.75v8.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75zm-4.5 0c.414 0 .75.336.75.75v8.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75zm-.75-5v-1c0-.535.474-1 1-1h4c.526 0 1 .465 1 1v1h5.254c.412 0 .746.335.746.747s-.334.747-.746.747h-16.507c-.413 0-.747-.335-.747-.747s.334-.747.747-.747zm4.5 0v-.5h-3v.5z"/></svg>
                                <span>Supprimer jour</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="dataUpdate.action" class="border border-gray-500 px-3 mx-3 p-4 rounded-lg relative mt-4">
                        <loading :active.sync="dataUpdate.loading1" :is-full-page="fullPage"></loading>
                        <p :class="!dataUpdate.date?'animation-pulse':''">
                            <date-picker placeholder="Date ..." @change="DateRange" format="YYYY-MM-DD"  class="w-full-imp" v-model="dataUpdate.date" ></date-picker>
                        </p>

                        <div v-if="dataUpdate.date && ['Ajouter','Modifier'].includes(dataUpdate.action)" class="border border-gray-500 mt-5  w-full  hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-2">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                <p>
                                <label for="seller" class="bg-white text-gray-700 px-1">{{$t('Horaires de travail')}} <span :class="$colors.required">*</span></label>
                                </p>
                            </div>
                            <div class="mt-3">
                               
                                <div class="grid lg:grid-cols-2 gap-6">

                                    <div
                                        class="border hover:border-green-400 w-full focus-within:border-green-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">Matin  <span :class="$colors.required">*</span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <v-select v-model="dataUpdate.matin" :options="dataUpdate.types"></v-select>
                                        </p>
                                    </div>

                                    <div
                                        class="border hover:border-green-400 w-full focus-within:border-green-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">Après-midi  <span :class="$colors.required">*</span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <v-select v-model="dataUpdate.midi" :options="dataUpdate.types"></v-select>
                                        </p>
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <button @click="$vm2.close('Params')"  class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Annuler</button>
                        <button :disabled="dataUpdate.loading" @click="Confirm()"  class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm relative loidingconfirm"><loading :active.sync="dataUpdate.loading" :is-full-page="fullPage"></loading> Confirmé </button>
                    </div>
                </div>
        </vue-modal-2>     
    </div>
</template>
<script>
//import button from "../../components/~/button.vue";
export default {
         props: {
            currentUser: { type: Object},
            idWharhouse: { type: Object},
        },
        data() {
            return {
                formData: {
                    carrier: {},
                    details: [],
                },
                show_modal: false,
                content: [],
                currency:'',
                options:this.$countries,
                dataUpdate:{ loading:false,loading1:false,date:null,action:null,types:['present','absent'],matin:'',midi:'' },
                pointages:[],
                loading:false,
                fullPage:false
            };
        },
        created() {
            let vm = this;
            document.addEventListener('readystatechange',async function (ev) {

               if (document.readyState == "complete") { 
                    console.log('pintage 111______')
                    const checking= vm.checkRouterQuery();
                    if(checking && vm.pointages.length === 0){
                        vm.loading=true;
                        const {content:data} = await vm.$server.search("pointages", {'user._id': vm.$route.params.id,country:vm.idWharhouse.country,Range_date:vm.$route.query.Range_date,salarie:false});
                        await vm.getData(data);
                        vm.loading=false;
                        console.log('res pointages______', vm.pointages)
                    }

                } 
            })
            
        },
        async mounted() {
            let vm = this;
            if (document.readyState == "complete") { 
                console.log('pintage 111______')
                const checking= vm.checkRouterQuery();
                if(checking && vm.pointages.length === 0){
                     vm.loading=true;
                    const {content:data} = await vm.$server.search("pointages", {'user._id': vm.$route.params.id,country:vm.idWharhouse.country,Range_date:vm.$route.query.Range_date,salarie:false});
                    await vm.getData(data);
                     vm.loading=false;
                    console.log('res pointages______', vm.pointages)
                }

            } 
        },
        computed: {
           
            
        },
        methods: {
            RouterBack: function() {
                this.$router.back();
            },
            async Action(name){
               this.dataUpdate.action=name;

               this.dataUpdate.date=null;
               this.dataUpdate.matin=null;
               this.dataUpdate.midi=null;
            },
            async getData(data){
                this.pointages=data.results;
            },
            async DateRange(data){
                var startDate = this.$route.query.Range_date.split(',')[0];
                var endDate  = new Date(this.$route.query.Range_date.split(',')[1]);

                endDate=this.$moment(endDate).add(1, 'days').format('yyyy-MM-DD');
                startDate=this.$moment(startDate).subtract(1, 'days').format('yyyy-MM-DD');
                data=this.$moment(data).format('yyyy-MM-DD');

                console.log('data date-------------------', data)
                console.log('startDate date-------------------', startDate)
                console.log('endDate date-------------------', endDate)
                if(!this.$moment(this.$moment(data).format('yyyy-MM-DD')).isBetween(this.$moment(startDate).format('yyyy-MM-DD'),this.$moment(endDate).format('yyyy-MM-DD'))) {
                    console.log('isBetween----',this.$moment(this.$moment(data).format('yyyy-MM-DD')).isBetween(this.$moment(startDate).format('yyyy-MM-DD'),this.$moment(endDate).format('yyyy-MM-DD')))
                    this.$toast.warning("Date n'existe pas dans cette periode dates"); 
                    this.dataUpdate.date=null;
                    this.dataUpdate.matin=null;
                    this.dataUpdate.midi=null;
                    return false;
                }

                if(this.dataUpdate.action === 'Modifier'){
                    this.dataUpdate.loading1=true;
                    const {content:dataPointage} = await this.$server.find("pointages", {'user._id': this.$route.params.id,country:this.idWharhouse.country,date:data,salarie:false});
                    this.dataUpdate.loading1=false;
                    console.log('dataPointage -------------------', dataPointage)
                    if(!dataPointage.results || (dataPointage.results && dataPointage.results.length === 0)){
                        this.$toast.warning("Utilisateur non pointé à cette date, choisissez une autre date n'existe pas dans cette periode dates"); 
                        this.dataUpdate.date=null;
                        this.dataUpdate.matin=null;
                        this.dataUpdate.midi=null;
                        return false;
                    }
                    const dataMatin= dataPointage.results.find(item => item.horaire === 'matin');
                    const dataMidi= dataPointage.results.find(item => item.horaire === 'après-midi');

                    this.dataUpdate.matin= dataMatin?dataMatin.type:null;
                    this.dataUpdate.midi= dataMidi?dataMidi.type:null;

                    console.log('dataUpdate -------------------',  this.dataUpdate)
                    
                }

            },
            async Confirm(name=null){

                if(!this.dataUpdate.action){
                    this.$toast.warning("Svp choisir une action"); 
                    return false
                }
                if(!this.dataUpdate.date){
                    this.$toast.warning("Svp choisir une date"); 
                    return false
                }
                if(['Ajouter','Modifier'].includes(this.dataUpdate.action) && (!this.dataUpdate.matin || !this.dataUpdate.midi)){
                    this.$toast.warning("Svp choisir Horaire du travaille"); 
                    return false
                }

                this.$confirm(`Êtes-vous sur de faire: `+this.dataUpdate.action+ ' Cette jour').then(async (action) => {
                    if (action) {
                        this.dataUpdate.user= this.$route.params.id;
                        this.dataUpdate.country= this.idWharhouse.country,
                        this.dataUpdate.loading=true;
                        const {content:data} = await this.$server.update("pointages",this.dataUpdate);
                        this.dataUpdate.loading=false;
                        console.log('ConfirmPayment data---------',data)
                        if(data && !data.error){
                            this.$vm2.close('Params');
                            this.dataUpdate.date=null;
                            this.dataUpdate.matin=null;
                            this.dataUpdate.midi=null;
                            this.dataUpdate.action=null;

                            this.$toast.success("Action faire avec success");
                            await this.reset();
                        }else this.$toast.warning(data.error||data);
                    }
                });    

            },
            async reset(){
                this.loading=true;
                const {content:data} = await this.$server.search("pointages", {'user._id': this.$route.params.id,country:this.idWharhouse.country,Range_date:this.$route.query.Range_date,salarie:false});
                await this.getData(data);
                this.loading=false;
           },
            getColors(name){
                // const result = ({
                //     'present': '',
                //     'absent': 'background-image: linear-gradient(120deg, #e71919 0%, #f08282 100%)',
                //     'N\'est pas pointer': 'background-image: linear-gradient(120deg, rgb(237 134 58) 0%, rgb(244 195 167) 100%)'
                // })[name] ?? 'Default';

              if(name === 'absent') return 'background-image: linear-gradient(120deg, #e71919 0%, #f08282 100%)';
              else if(name === 'N\'est pas pointer') return 'background-image: linear-gradient(120deg, rgb(237 134 58) 0%, rgb(244 195 167) 100%)';
              else return ''

               
            },
            checkEmployeur(datas,horaire=null,type=null){
                let data=null;
                if(horaire){
                    const res=datas.find(el=> el.horaire === horaire);
                   if(res && res.hours) data=res.type;
                   else data="N'est pas pointer";
                }
                if(type){
                    //console.log('data-----',datas)
                    data= datas.filter(el=> el.type === type).reduce((n, {hours}) => n + hours, 0);
                }
              
                return data;
            },
            checkRouterQuery: function() {
               var checking=true;
               if(!this.$route.params.id){
                    this.$toast.warning("User ID not defined return a la page précédente et essayer encore une fois"); 
                    checking=false;
               }
              
               if(!this.$route.query.Range_date){
                    this.$toast.warning("Range date not defined return a la page précédente et essayer encore une fois"); 
                    checking=false;
               }
               return checking;
             
            },
            async getwharhouse(){
                const resW = await this.$server.get("warehouses", { country: this.formData.country_to}); 
                if(resW.content) return  this.currency=resW.content.currency;
            },
            async getUser() {
                const res = await this.$me;
                this.currentUser = res.content;
            },
            /*******************************************Modal (View) update Chapping address and Status Order ************************************/
            ShowPopUpInformation(index) {
                let modal_id = "modal_" + index;
                this.$refs[modal_id][0].showModal();
            },
            async closePopUpInformation(index) {
                let modal_id = "modal_" + index;
                this.$refs[modal_id][0].close();
            },

            /**************************Fin Modal ****************************** */
        },
    };
</script>

<style scoped>
 table {
  border-collapse: separate;
  text-indent: 0;
  border-spacing: 2px;
}
table thead th {
  background-image: linear-gradient(120deg, #19706a 0%, #1ba79e 100%);
  border: 1px solid #4e504a;
  font-weight: 500;
  color: #faf4f4;
}
td,
th {
  border: 1px solid #000;
  border-collapse: collapse;
}
.font-semibold{
    font-weight: 600 !important;
}
</style>